export default __webpack_public_path__ + "static/media/show-feeder-1.2409ccd5.webp";